import LC from '@constants/login';
import { RL, SK } from '@constants';
import { httpRequest } from '@lib';
import { StorageUtility } from '@utils';

export const logoutUser = async () => {
  try {
    await httpRequest.post(LC.LOGOUT_URI);
    const ci = StorageUtility.getItem(SK.CI);
    StorageUtility.clear();
    if (ci) StorageUtility.setItem(SK.CI, ci);

    return window.location.replace(`/${RL.AUTHENTICATE}`);
  } catch (err) {
    console.log({ err });

    const ci = StorageUtility.getItem(SK.CI);
    StorageUtility.clear();
    if (ci) StorageUtility.setItem(SK.CI, ci);

    return setTimeout(() => {
      window.location.replace(`/${RL.AUTHENTICATE}`);
    }, 0);
  }
};
